import { NavLink, useLocation } from "react-router-dom"

export default function PNavLink({ to, ...props }) {
  const location = useLocation();

  return (
    <NavLink to={{ pathname: to, search: location.search }} {...props} />
  )
}